export  function isVaild(key) {
    if (typeof(key)==='undefined'){
        return false
    }
    if(key === null){
        return false
    }
    return true
}

export default {
    isVaild,
}
